var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7209 1.65908L49.5718 20.4442H49.5585C50.1472 21.4744 50.1472 22.7321 49.5585 23.7624L38.7075 42.5475C38.1188 43.5777 37.0217 44.2066 35.8443 44.2066H14.1557C12.9783 44.2066 11.8812 43.5777 11.2925 42.5475L0.441531 23.7624C-0.147177 22.7321 -0.147177 21.4744 0.441531 20.4442L11.2925 1.65908C11.8812 0.628847 12.9783 0 14.1557 0H35.8576C37.0351 0 38.1322 0.628847 38.7209 1.65908ZM6.50254 22.1033C6.50254 32.3254 14.7846 40.6074 25.0067 40.6074C35.2288 40.6074 43.5108 32.3254 43.5108 22.1033C43.5108 11.8812 35.2288 3.59914 25.0067 3.59914C14.7846 3.59914 6.50254 11.8812 6.50254 22.1033ZM8.28192 22.1035C8.28192 12.8715 15.7746 5.37886 25.0066 5.37886C34.2386 5.37886 41.7312 12.8715 41.7312 22.1035C41.7312 31.3355 34.2386 38.8281 25.0066 38.8281C15.7746 38.8281 8.28192 31.3355 8.28192 22.1035ZM10.9579 22.0901C10.9579 29.8504 17.2463 36.1388 25.0066 36.1388C32.7668 36.1388 39.0553 29.8504 39.0553 22.0901C39.0553 14.3299 32.7668 8.04143 25.0066 8.04143C17.2463 8.04143 10.9579 14.3299 10.9579 22.0901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.03609ba0b64176a872e57262da188989.svg";
export { ForwardRef as ReactComponent };